import { Panel, } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";
import type { CSSProperties, MouseEventHandler, ReactNode, } from "react";
import styled from "styled-components";

export const Carded = styled(Panel)`
	gap: 32px;
	padding: 24px;
	border-radius: 8px;
	border: 1px solid ${() => getTheme().surface_on};
	background-color: ${() => getTheme().surface_container};
`;
